import { __assign } from "tslib";
export var DescribeInstanceEventNotificationAttributesResult;
(function (DescribeInstanceEventNotificationAttributesResult) {
    /**
     * @internal
     */
    DescribeInstanceEventNotificationAttributesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceEventNotificationAttributesResult || (DescribeInstanceEventNotificationAttributesResult = {}));
export var DescribeInstanceEventWindowsRequest;
(function (DescribeInstanceEventWindowsRequest) {
    /**
     * @internal
     */
    DescribeInstanceEventWindowsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceEventWindowsRequest || (DescribeInstanceEventWindowsRequest = {}));
export var DescribeInstanceEventWindowsResult;
(function (DescribeInstanceEventWindowsResult) {
    /**
     * @internal
     */
    DescribeInstanceEventWindowsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceEventWindowsResult || (DescribeInstanceEventWindowsResult = {}));
export var DescribeInstancesRequest;
(function (DescribeInstancesRequest) {
    /**
     * @internal
     */
    DescribeInstancesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstancesRequest || (DescribeInstancesRequest = {}));
export var CapacityReservationSpecificationResponse;
(function (CapacityReservationSpecificationResponse) {
    /**
     * @internal
     */
    CapacityReservationSpecificationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CapacityReservationSpecificationResponse || (CapacityReservationSpecificationResponse = {}));
export var CpuOptions;
(function (CpuOptions) {
    /**
     * @internal
     */
    CpuOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CpuOptions || (CpuOptions = {}));
export var ElasticGpuAssociation;
(function (ElasticGpuAssociation) {
    /**
     * @internal
     */
    ElasticGpuAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ElasticGpuAssociation || (ElasticGpuAssociation = {}));
export var ElasticInferenceAcceleratorAssociation;
(function (ElasticInferenceAcceleratorAssociation) {
    /**
     * @internal
     */
    ElasticInferenceAcceleratorAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ElasticInferenceAcceleratorAssociation || (ElasticInferenceAcceleratorAssociation = {}));
export var HibernationOptions;
(function (HibernationOptions) {
    /**
     * @internal
     */
    HibernationOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HibernationOptions || (HibernationOptions = {}));
export var LicenseConfiguration;
(function (LicenseConfiguration) {
    /**
     * @internal
     */
    LicenseConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LicenseConfiguration || (LicenseConfiguration = {}));
export var InstanceMetadataProtocolState;
(function (InstanceMetadataProtocolState) {
    InstanceMetadataProtocolState["disabled"] = "disabled";
    InstanceMetadataProtocolState["enabled"] = "enabled";
})(InstanceMetadataProtocolState || (InstanceMetadataProtocolState = {}));
export var HttpTokensState;
(function (HttpTokensState) {
    HttpTokensState["optional"] = "optional";
    HttpTokensState["required"] = "required";
})(HttpTokensState || (HttpTokensState = {}));
export var InstanceMetadataOptionsResponse;
(function (InstanceMetadataOptionsResponse) {
    /**
     * @internal
     */
    InstanceMetadataOptionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceMetadataOptionsResponse || (InstanceMetadataOptionsResponse = {}));
export var Monitoring;
(function (Monitoring) {
    /**
     * @internal
     */
    Monitoring.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Monitoring || (Monitoring = {}));
export var InstanceNetworkInterfaceAssociation;
(function (InstanceNetworkInterfaceAssociation) {
    /**
     * @internal
     */
    InstanceNetworkInterfaceAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceNetworkInterfaceAssociation || (InstanceNetworkInterfaceAssociation = {}));
export var InstanceNetworkInterfaceAttachment;
(function (InstanceNetworkInterfaceAttachment) {
    /**
     * @internal
     */
    InstanceNetworkInterfaceAttachment.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceNetworkInterfaceAttachment || (InstanceNetworkInterfaceAttachment = {}));
export var InstanceIpv4Prefix;
(function (InstanceIpv4Prefix) {
    /**
     * @internal
     */
    InstanceIpv4Prefix.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceIpv4Prefix || (InstanceIpv4Prefix = {}));
export var InstanceIpv6Prefix;
(function (InstanceIpv6Prefix) {
    /**
     * @internal
     */
    InstanceIpv6Prefix.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceIpv6Prefix || (InstanceIpv6Prefix = {}));
export var InstancePrivateIpAddress;
(function (InstancePrivateIpAddress) {
    /**
     * @internal
     */
    InstancePrivateIpAddress.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstancePrivateIpAddress || (InstancePrivateIpAddress = {}));
export var InstanceNetworkInterface;
(function (InstanceNetworkInterface) {
    /**
     * @internal
     */
    InstanceNetworkInterface.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceNetworkInterface || (InstanceNetworkInterface = {}));
export var InstanceState;
(function (InstanceState) {
    /**
     * @internal
     */
    InstanceState.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceState || (InstanceState = {}));
export var Instance;
(function (Instance) {
    /**
     * @internal
     */
    Instance.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Instance || (Instance = {}));
export var Reservation;
(function (Reservation) {
    /**
     * @internal
     */
    Reservation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Reservation || (Reservation = {}));
export var DescribeInstancesResult;
(function (DescribeInstancesResult) {
    /**
     * @internal
     */
    DescribeInstancesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstancesResult || (DescribeInstancesResult = {}));
export var DescribeInstanceStatusRequest;
(function (DescribeInstanceStatusRequest) {
    /**
     * @internal
     */
    DescribeInstanceStatusRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceStatusRequest || (DescribeInstanceStatusRequest = {}));
export var InstanceStatusEvent;
(function (InstanceStatusEvent) {
    /**
     * @internal
     */
    InstanceStatusEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceStatusEvent || (InstanceStatusEvent = {}));
export var InstanceStatusDetails;
(function (InstanceStatusDetails) {
    /**
     * @internal
     */
    InstanceStatusDetails.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceStatusDetails || (InstanceStatusDetails = {}));
export var InstanceStatusSummary;
(function (InstanceStatusSummary) {
    /**
     * @internal
     */
    InstanceStatusSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceStatusSummary || (InstanceStatusSummary = {}));
export var InstanceStatus;
(function (InstanceStatus) {
    /**
     * @internal
     */
    InstanceStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceStatus || (InstanceStatus = {}));
export var DescribeInstanceStatusResult;
(function (DescribeInstanceStatusResult) {
    /**
     * @internal
     */
    DescribeInstanceStatusResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceStatusResult || (DescribeInstanceStatusResult = {}));
export var DescribeInstanceTypeOfferingsRequest;
(function (DescribeInstanceTypeOfferingsRequest) {
    /**
     * @internal
     */
    DescribeInstanceTypeOfferingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceTypeOfferingsRequest || (DescribeInstanceTypeOfferingsRequest = {}));
export var InstanceTypeOffering;
(function (InstanceTypeOffering) {
    /**
     * @internal
     */
    InstanceTypeOffering.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceTypeOffering || (InstanceTypeOffering = {}));
export var DescribeInstanceTypeOfferingsResult;
(function (DescribeInstanceTypeOfferingsResult) {
    /**
     * @internal
     */
    DescribeInstanceTypeOfferingsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceTypeOfferingsResult || (DescribeInstanceTypeOfferingsResult = {}));
export var DescribeInstanceTypesRequest;
(function (DescribeInstanceTypesRequest) {
    /**
     * @internal
     */
    DescribeInstanceTypesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceTypesRequest || (DescribeInstanceTypesRequest = {}));
export var EbsOptimizedInfo;
(function (EbsOptimizedInfo) {
    /**
     * @internal
     */
    EbsOptimizedInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EbsOptimizedInfo || (EbsOptimizedInfo = {}));
export var EbsNvmeSupport;
(function (EbsNvmeSupport) {
    EbsNvmeSupport["REQUIRED"] = "required";
    EbsNvmeSupport["SUPPORTED"] = "supported";
    EbsNvmeSupport["UNSUPPORTED"] = "unsupported";
})(EbsNvmeSupport || (EbsNvmeSupport = {}));
export var EbsInfo;
(function (EbsInfo) {
    /**
     * @internal
     */
    EbsInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EbsInfo || (EbsInfo = {}));
export var FpgaDeviceMemoryInfo;
(function (FpgaDeviceMemoryInfo) {
    /**
     * @internal
     */
    FpgaDeviceMemoryInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FpgaDeviceMemoryInfo || (FpgaDeviceMemoryInfo = {}));
export var FpgaDeviceInfo;
(function (FpgaDeviceInfo) {
    /**
     * @internal
     */
    FpgaDeviceInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FpgaDeviceInfo || (FpgaDeviceInfo = {}));
export var FpgaInfo;
(function (FpgaInfo) {
    /**
     * @internal
     */
    FpgaInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FpgaInfo || (FpgaInfo = {}));
export var GpuDeviceMemoryInfo;
(function (GpuDeviceMemoryInfo) {
    /**
     * @internal
     */
    GpuDeviceMemoryInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GpuDeviceMemoryInfo || (GpuDeviceMemoryInfo = {}));
export var GpuDeviceInfo;
(function (GpuDeviceInfo) {
    /**
     * @internal
     */
    GpuDeviceInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GpuDeviceInfo || (GpuDeviceInfo = {}));
export var GpuInfo;
(function (GpuInfo) {
    /**
     * @internal
     */
    GpuInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GpuInfo || (GpuInfo = {}));
export var InstanceTypeHypervisor;
(function (InstanceTypeHypervisor) {
    InstanceTypeHypervisor["NITRO"] = "nitro";
    InstanceTypeHypervisor["XEN"] = "xen";
})(InstanceTypeHypervisor || (InstanceTypeHypervisor = {}));
export var InferenceDeviceInfo;
(function (InferenceDeviceInfo) {
    /**
     * @internal
     */
    InferenceDeviceInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InferenceDeviceInfo || (InferenceDeviceInfo = {}));
export var InferenceAcceleratorInfo;
(function (InferenceAcceleratorInfo) {
    /**
     * @internal
     */
    InferenceAcceleratorInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InferenceAcceleratorInfo || (InferenceAcceleratorInfo = {}));
export var DiskInfo;
(function (DiskInfo) {
    /**
     * @internal
     */
    DiskInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DiskInfo || (DiskInfo = {}));
export var EphemeralNvmeSupport;
(function (EphemeralNvmeSupport) {
    EphemeralNvmeSupport["REQUIRED"] = "required";
    EphemeralNvmeSupport["SUPPORTED"] = "supported";
    EphemeralNvmeSupport["UNSUPPORTED"] = "unsupported";
})(EphemeralNvmeSupport || (EphemeralNvmeSupport = {}));
export var InstanceStorageInfo;
(function (InstanceStorageInfo) {
    /**
     * @internal
     */
    InstanceStorageInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceStorageInfo || (InstanceStorageInfo = {}));
export var MemoryInfo;
(function (MemoryInfo) {
    /**
     * @internal
     */
    MemoryInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MemoryInfo || (MemoryInfo = {}));
export var EfaInfo;
(function (EfaInfo) {
    /**
     * @internal
     */
    EfaInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EfaInfo || (EfaInfo = {}));
export var NetworkCardInfo;
(function (NetworkCardInfo) {
    /**
     * @internal
     */
    NetworkCardInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NetworkCardInfo || (NetworkCardInfo = {}));
export var NetworkInfo;
(function (NetworkInfo) {
    /**
     * @internal
     */
    NetworkInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NetworkInfo || (NetworkInfo = {}));
export var PlacementGroupInfo;
(function (PlacementGroupInfo) {
    /**
     * @internal
     */
    PlacementGroupInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PlacementGroupInfo || (PlacementGroupInfo = {}));
export var ProcessorInfo;
(function (ProcessorInfo) {
    /**
     * @internal
     */
    ProcessorInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProcessorInfo || (ProcessorInfo = {}));
export var VCpuInfo;
(function (VCpuInfo) {
    /**
     * @internal
     */
    VCpuInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VCpuInfo || (VCpuInfo = {}));
export var InstanceTypeInfo;
(function (InstanceTypeInfo) {
    /**
     * @internal
     */
    InstanceTypeInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceTypeInfo || (InstanceTypeInfo = {}));
export var DescribeInstanceTypesResult;
(function (DescribeInstanceTypesResult) {
    /**
     * @internal
     */
    DescribeInstanceTypesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInstanceTypesResult || (DescribeInstanceTypesResult = {}));
export var DescribeInternetGatewaysRequest;
(function (DescribeInternetGatewaysRequest) {
    /**
     * @internal
     */
    DescribeInternetGatewaysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInternetGatewaysRequest || (DescribeInternetGatewaysRequest = {}));
export var DescribeInternetGatewaysResult;
(function (DescribeInternetGatewaysResult) {
    /**
     * @internal
     */
    DescribeInternetGatewaysResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeInternetGatewaysResult || (DescribeInternetGatewaysResult = {}));
export var DescribeIpv6PoolsRequest;
(function (DescribeIpv6PoolsRequest) {
    /**
     * @internal
     */
    DescribeIpv6PoolsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeIpv6PoolsRequest || (DescribeIpv6PoolsRequest = {}));
export var PoolCidrBlock;
(function (PoolCidrBlock) {
    /**
     * @internal
     */
    PoolCidrBlock.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PoolCidrBlock || (PoolCidrBlock = {}));
export var Ipv6Pool;
(function (Ipv6Pool) {
    /**
     * @internal
     */
    Ipv6Pool.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Ipv6Pool || (Ipv6Pool = {}));
export var DescribeIpv6PoolsResult;
(function (DescribeIpv6PoolsResult) {
    /**
     * @internal
     */
    DescribeIpv6PoolsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeIpv6PoolsResult || (DescribeIpv6PoolsResult = {}));
export var DescribeKeyPairsRequest;
(function (DescribeKeyPairsRequest) {
    /**
     * @internal
     */
    DescribeKeyPairsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeKeyPairsRequest || (DescribeKeyPairsRequest = {}));
export var KeyPairInfo;
(function (KeyPairInfo) {
    /**
     * @internal
     */
    KeyPairInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyPairInfo || (KeyPairInfo = {}));
export var DescribeKeyPairsResult;
(function (DescribeKeyPairsResult) {
    /**
     * @internal
     */
    DescribeKeyPairsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeKeyPairsResult || (DescribeKeyPairsResult = {}));
export var DescribeLaunchTemplatesRequest;
(function (DescribeLaunchTemplatesRequest) {
    /**
     * @internal
     */
    DescribeLaunchTemplatesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLaunchTemplatesRequest || (DescribeLaunchTemplatesRequest = {}));
export var DescribeLaunchTemplatesResult;
(function (DescribeLaunchTemplatesResult) {
    /**
     * @internal
     */
    DescribeLaunchTemplatesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLaunchTemplatesResult || (DescribeLaunchTemplatesResult = {}));
export var DescribeLaunchTemplateVersionsRequest;
(function (DescribeLaunchTemplateVersionsRequest) {
    /**
     * @internal
     */
    DescribeLaunchTemplateVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLaunchTemplateVersionsRequest || (DescribeLaunchTemplateVersionsRequest = {}));
export var DescribeLaunchTemplateVersionsResult;
(function (DescribeLaunchTemplateVersionsResult) {
    /**
     * @internal
     */
    DescribeLaunchTemplateVersionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLaunchTemplateVersionsResult || (DescribeLaunchTemplateVersionsResult = {}));
export var DescribeLocalGatewayRouteTablesRequest;
(function (DescribeLocalGatewayRouteTablesRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTablesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTablesRequest || (DescribeLocalGatewayRouteTablesRequest = {}));
export var LocalGatewayRouteTable;
(function (LocalGatewayRouteTable) {
    /**
     * @internal
     */
    LocalGatewayRouteTable.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LocalGatewayRouteTable || (LocalGatewayRouteTable = {}));
export var DescribeLocalGatewayRouteTablesResult;
(function (DescribeLocalGatewayRouteTablesResult) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTablesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTablesResult || (DescribeLocalGatewayRouteTablesResult = {}));
export var DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsRequest;
(function (DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsRequest || (DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsRequest = {}));
export var LocalGatewayRouteTableVirtualInterfaceGroupAssociation;
(function (LocalGatewayRouteTableVirtualInterfaceGroupAssociation) {
    /**
     * @internal
     */
    LocalGatewayRouteTableVirtualInterfaceGroupAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LocalGatewayRouteTableVirtualInterfaceGroupAssociation || (LocalGatewayRouteTableVirtualInterfaceGroupAssociation = {}));
export var DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsResult;
(function (DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsResult) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsResult || (DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociationsResult = {}));
export var DescribeLocalGatewayRouteTableVpcAssociationsRequest;
(function (DescribeLocalGatewayRouteTableVpcAssociationsRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTableVpcAssociationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTableVpcAssociationsRequest || (DescribeLocalGatewayRouteTableVpcAssociationsRequest = {}));
export var DescribeLocalGatewayRouteTableVpcAssociationsResult;
(function (DescribeLocalGatewayRouteTableVpcAssociationsResult) {
    /**
     * @internal
     */
    DescribeLocalGatewayRouteTableVpcAssociationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayRouteTableVpcAssociationsResult || (DescribeLocalGatewayRouteTableVpcAssociationsResult = {}));
export var DescribeLocalGatewaysRequest;
(function (DescribeLocalGatewaysRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewaysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewaysRequest || (DescribeLocalGatewaysRequest = {}));
export var LocalGateway;
(function (LocalGateway) {
    /**
     * @internal
     */
    LocalGateway.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LocalGateway || (LocalGateway = {}));
export var DescribeLocalGatewaysResult;
(function (DescribeLocalGatewaysResult) {
    /**
     * @internal
     */
    DescribeLocalGatewaysResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewaysResult || (DescribeLocalGatewaysResult = {}));
export var DescribeLocalGatewayVirtualInterfaceGroupsRequest;
(function (DescribeLocalGatewayVirtualInterfaceGroupsRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewayVirtualInterfaceGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayVirtualInterfaceGroupsRequest || (DescribeLocalGatewayVirtualInterfaceGroupsRequest = {}));
export var LocalGatewayVirtualInterfaceGroup;
(function (LocalGatewayVirtualInterfaceGroup) {
    /**
     * @internal
     */
    LocalGatewayVirtualInterfaceGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LocalGatewayVirtualInterfaceGroup || (LocalGatewayVirtualInterfaceGroup = {}));
export var DescribeLocalGatewayVirtualInterfaceGroupsResult;
(function (DescribeLocalGatewayVirtualInterfaceGroupsResult) {
    /**
     * @internal
     */
    DescribeLocalGatewayVirtualInterfaceGroupsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayVirtualInterfaceGroupsResult || (DescribeLocalGatewayVirtualInterfaceGroupsResult = {}));
export var DescribeLocalGatewayVirtualInterfacesRequest;
(function (DescribeLocalGatewayVirtualInterfacesRequest) {
    /**
     * @internal
     */
    DescribeLocalGatewayVirtualInterfacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayVirtualInterfacesRequest || (DescribeLocalGatewayVirtualInterfacesRequest = {}));
export var LocalGatewayVirtualInterface;
(function (LocalGatewayVirtualInterface) {
    /**
     * @internal
     */
    LocalGatewayVirtualInterface.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LocalGatewayVirtualInterface || (LocalGatewayVirtualInterface = {}));
export var DescribeLocalGatewayVirtualInterfacesResult;
(function (DescribeLocalGatewayVirtualInterfacesResult) {
    /**
     * @internal
     */
    DescribeLocalGatewayVirtualInterfacesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLocalGatewayVirtualInterfacesResult || (DescribeLocalGatewayVirtualInterfacesResult = {}));
export var DescribeManagedPrefixListsRequest;
(function (DescribeManagedPrefixListsRequest) {
    /**
     * @internal
     */
    DescribeManagedPrefixListsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeManagedPrefixListsRequest || (DescribeManagedPrefixListsRequest = {}));
export var DescribeManagedPrefixListsResult;
(function (DescribeManagedPrefixListsResult) {
    /**
     * @internal
     */
    DescribeManagedPrefixListsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeManagedPrefixListsResult || (DescribeManagedPrefixListsResult = {}));
export var DescribeMovingAddressesRequest;
(function (DescribeMovingAddressesRequest) {
    /**
     * @internal
     */
    DescribeMovingAddressesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeMovingAddressesRequest || (DescribeMovingAddressesRequest = {}));
export var MovingAddressStatus;
(function (MovingAddressStatus) {
    /**
     * @internal
     */
    MovingAddressStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MovingAddressStatus || (MovingAddressStatus = {}));
export var DescribeMovingAddressesResult;
(function (DescribeMovingAddressesResult) {
    /**
     * @internal
     */
    DescribeMovingAddressesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeMovingAddressesResult || (DescribeMovingAddressesResult = {}));
export var DescribeNatGatewaysRequest;
(function (DescribeNatGatewaysRequest) {
    /**
     * @internal
     */
    DescribeNatGatewaysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNatGatewaysRequest || (DescribeNatGatewaysRequest = {}));
export var DescribeNatGatewaysResult;
(function (DescribeNatGatewaysResult) {
    /**
     * @internal
     */
    DescribeNatGatewaysResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNatGatewaysResult || (DescribeNatGatewaysResult = {}));
export var DescribeNetworkAclsRequest;
(function (DescribeNetworkAclsRequest) {
    /**
     * @internal
     */
    DescribeNetworkAclsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkAclsRequest || (DescribeNetworkAclsRequest = {}));
export var DescribeNetworkAclsResult;
(function (DescribeNetworkAclsResult) {
    /**
     * @internal
     */
    DescribeNetworkAclsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkAclsResult || (DescribeNetworkAclsResult = {}));
export var DescribeNetworkInsightsAnalysesRequest;
(function (DescribeNetworkInsightsAnalysesRequest) {
    /**
     * @internal
     */
    DescribeNetworkInsightsAnalysesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInsightsAnalysesRequest || (DescribeNetworkInsightsAnalysesRequest = {}));
export var AnalysisComponent;
(function (AnalysisComponent) {
    /**
     * @internal
     */
    AnalysisComponent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisComponent || (AnalysisComponent = {}));
export var AnalysisAclRule;
(function (AnalysisAclRule) {
    /**
     * @internal
     */
    AnalysisAclRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisAclRule || (AnalysisAclRule = {}));
export var AnalysisLoadBalancerListener;
(function (AnalysisLoadBalancerListener) {
    /**
     * @internal
     */
    AnalysisLoadBalancerListener.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisLoadBalancerListener || (AnalysisLoadBalancerListener = {}));
export var AnalysisLoadBalancerTarget;
(function (AnalysisLoadBalancerTarget) {
    /**
     * @internal
     */
    AnalysisLoadBalancerTarget.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisLoadBalancerTarget || (AnalysisLoadBalancerTarget = {}));
export var AnalysisRouteTableRoute;
(function (AnalysisRouteTableRoute) {
    /**
     * @internal
     */
    AnalysisRouteTableRoute.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisRouteTableRoute || (AnalysisRouteTableRoute = {}));
export var AnalysisSecurityGroupRule;
(function (AnalysisSecurityGroupRule) {
    /**
     * @internal
     */
    AnalysisSecurityGroupRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisSecurityGroupRule || (AnalysisSecurityGroupRule = {}));
export var Explanation;
(function (Explanation) {
    /**
     * @internal
     */
    Explanation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Explanation || (Explanation = {}));
export var AnalysisPacketHeader;
(function (AnalysisPacketHeader) {
    /**
     * @internal
     */
    AnalysisPacketHeader.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AnalysisPacketHeader || (AnalysisPacketHeader = {}));
export var PathComponent;
(function (PathComponent) {
    /**
     * @internal
     */
    PathComponent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PathComponent || (PathComponent = {}));
export var NetworkInsightsAnalysis;
(function (NetworkInsightsAnalysis) {
    /**
     * @internal
     */
    NetworkInsightsAnalysis.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NetworkInsightsAnalysis || (NetworkInsightsAnalysis = {}));
export var DescribeNetworkInsightsAnalysesResult;
(function (DescribeNetworkInsightsAnalysesResult) {
    /**
     * @internal
     */
    DescribeNetworkInsightsAnalysesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInsightsAnalysesResult || (DescribeNetworkInsightsAnalysesResult = {}));
export var DescribeNetworkInsightsPathsRequest;
(function (DescribeNetworkInsightsPathsRequest) {
    /**
     * @internal
     */
    DescribeNetworkInsightsPathsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInsightsPathsRequest || (DescribeNetworkInsightsPathsRequest = {}));
export var DescribeNetworkInsightsPathsResult;
(function (DescribeNetworkInsightsPathsResult) {
    /**
     * @internal
     */
    DescribeNetworkInsightsPathsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInsightsPathsResult || (DescribeNetworkInsightsPathsResult = {}));
export var DescribeNetworkInterfaceAttributeRequest;
(function (DescribeNetworkInterfaceAttributeRequest) {
    /**
     * @internal
     */
    DescribeNetworkInterfaceAttributeRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfaceAttributeRequest || (DescribeNetworkInterfaceAttributeRequest = {}));
export var DescribeNetworkInterfaceAttributeResult;
(function (DescribeNetworkInterfaceAttributeResult) {
    /**
     * @internal
     */
    DescribeNetworkInterfaceAttributeResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfaceAttributeResult || (DescribeNetworkInterfaceAttributeResult = {}));
export var DescribeNetworkInterfacePermissionsRequest;
(function (DescribeNetworkInterfacePermissionsRequest) {
    /**
     * @internal
     */
    DescribeNetworkInterfacePermissionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfacePermissionsRequest || (DescribeNetworkInterfacePermissionsRequest = {}));
export var DescribeNetworkInterfacePermissionsResult;
(function (DescribeNetworkInterfacePermissionsResult) {
    /**
     * @internal
     */
    DescribeNetworkInterfacePermissionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfacePermissionsResult || (DescribeNetworkInterfacePermissionsResult = {}));
export var DescribeNetworkInterfacesRequest;
(function (DescribeNetworkInterfacesRequest) {
    /**
     * @internal
     */
    DescribeNetworkInterfacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfacesRequest || (DescribeNetworkInterfacesRequest = {}));
export var DescribeNetworkInterfacesResult;
(function (DescribeNetworkInterfacesResult) {
    /**
     * @internal
     */
    DescribeNetworkInterfacesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeNetworkInterfacesResult || (DescribeNetworkInterfacesResult = {}));
export var DescribePlacementGroupsRequest;
(function (DescribePlacementGroupsRequest) {
    /**
     * @internal
     */
    DescribePlacementGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePlacementGroupsRequest || (DescribePlacementGroupsRequest = {}));
export var DescribePlacementGroupsResult;
(function (DescribePlacementGroupsResult) {
    /**
     * @internal
     */
    DescribePlacementGroupsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePlacementGroupsResult || (DescribePlacementGroupsResult = {}));
export var DescribePrefixListsRequest;
(function (DescribePrefixListsRequest) {
    /**
     * @internal
     */
    DescribePrefixListsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePrefixListsRequest || (DescribePrefixListsRequest = {}));
export var PrefixList;
(function (PrefixList) {
    /**
     * @internal
     */
    PrefixList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PrefixList || (PrefixList = {}));
export var DescribePrefixListsResult;
(function (DescribePrefixListsResult) {
    /**
     * @internal
     */
    DescribePrefixListsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePrefixListsResult || (DescribePrefixListsResult = {}));
export var DescribePrincipalIdFormatRequest;
(function (DescribePrincipalIdFormatRequest) {
    /**
     * @internal
     */
    DescribePrincipalIdFormatRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePrincipalIdFormatRequest || (DescribePrincipalIdFormatRequest = {}));
export var PrincipalIdFormat;
(function (PrincipalIdFormat) {
    /**
     * @internal
     */
    PrincipalIdFormat.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PrincipalIdFormat || (PrincipalIdFormat = {}));
export var DescribePrincipalIdFormatResult;
(function (DescribePrincipalIdFormatResult) {
    /**
     * @internal
     */
    DescribePrincipalIdFormatResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePrincipalIdFormatResult || (DescribePrincipalIdFormatResult = {}));
export var DescribePublicIpv4PoolsRequest;
(function (DescribePublicIpv4PoolsRequest) {
    /**
     * @internal
     */
    DescribePublicIpv4PoolsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePublicIpv4PoolsRequest || (DescribePublicIpv4PoolsRequest = {}));
export var PublicIpv4PoolRange;
(function (PublicIpv4PoolRange) {
    /**
     * @internal
     */
    PublicIpv4PoolRange.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicIpv4PoolRange || (PublicIpv4PoolRange = {}));
export var PublicIpv4Pool;
(function (PublicIpv4Pool) {
    /**
     * @internal
     */
    PublicIpv4Pool.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicIpv4Pool || (PublicIpv4Pool = {}));
export var DescribePublicIpv4PoolsResult;
(function (DescribePublicIpv4PoolsResult) {
    /**
     * @internal
     */
    DescribePublicIpv4PoolsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribePublicIpv4PoolsResult || (DescribePublicIpv4PoolsResult = {}));
export var DescribeRegionsRequest;
(function (DescribeRegionsRequest) {
    /**
     * @internal
     */
    DescribeRegionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeRegionsRequest || (DescribeRegionsRequest = {}));
export var Region;
(function (Region) {
    /**
     * @internal
     */
    Region.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Region || (Region = {}));
export var DescribeRegionsResult;
(function (DescribeRegionsResult) {
    /**
     * @internal
     */
    DescribeRegionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeRegionsResult || (DescribeRegionsResult = {}));
export var DescribeReplaceRootVolumeTasksRequest;
(function (DescribeReplaceRootVolumeTasksRequest) {
    /**
     * @internal
     */
    DescribeReplaceRootVolumeTasksRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReplaceRootVolumeTasksRequest || (DescribeReplaceRootVolumeTasksRequest = {}));
export var DescribeReplaceRootVolumeTasksResult;
(function (DescribeReplaceRootVolumeTasksResult) {
    /**
     * @internal
     */
    DescribeReplaceRootVolumeTasksResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReplaceRootVolumeTasksResult || (DescribeReplaceRootVolumeTasksResult = {}));
export var OfferingClassType;
(function (OfferingClassType) {
    OfferingClassType["CONVERTIBLE"] = "convertible";
    OfferingClassType["STANDARD"] = "standard";
})(OfferingClassType || (OfferingClassType = {}));
export var DescribeReservedInstancesRequest;
(function (DescribeReservedInstancesRequest) {
    /**
     * @internal
     */
    DescribeReservedInstancesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesRequest || (DescribeReservedInstancesRequest = {}));
export var RecurringCharge;
(function (RecurringCharge) {
    /**
     * @internal
     */
    RecurringCharge.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RecurringCharge || (RecurringCharge = {}));
export var Scope;
(function (Scope) {
    Scope["AVAILABILITY_ZONE"] = "Availability Zone";
    Scope["REGIONAL"] = "Region";
})(Scope || (Scope = {}));
export var ReservedInstances;
(function (ReservedInstances) {
    /**
     * @internal
     */
    ReservedInstances.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstances || (ReservedInstances = {}));
export var DescribeReservedInstancesResult;
(function (DescribeReservedInstancesResult) {
    /**
     * @internal
     */
    DescribeReservedInstancesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesResult || (DescribeReservedInstancesResult = {}));
export var DescribeReservedInstancesListingsRequest;
(function (DescribeReservedInstancesListingsRequest) {
    /**
     * @internal
     */
    DescribeReservedInstancesListingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesListingsRequest || (DescribeReservedInstancesListingsRequest = {}));
export var DescribeReservedInstancesListingsResult;
(function (DescribeReservedInstancesListingsResult) {
    /**
     * @internal
     */
    DescribeReservedInstancesListingsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesListingsResult || (DescribeReservedInstancesListingsResult = {}));
export var DescribeReservedInstancesModificationsRequest;
(function (DescribeReservedInstancesModificationsRequest) {
    /**
     * @internal
     */
    DescribeReservedInstancesModificationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesModificationsRequest || (DescribeReservedInstancesModificationsRequest = {}));
export var ReservedInstancesConfiguration;
(function (ReservedInstancesConfiguration) {
    /**
     * @internal
     */
    ReservedInstancesConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstancesConfiguration || (ReservedInstancesConfiguration = {}));
export var ReservedInstancesModificationResult;
(function (ReservedInstancesModificationResult) {
    /**
     * @internal
     */
    ReservedInstancesModificationResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstancesModificationResult || (ReservedInstancesModificationResult = {}));
export var ReservedInstancesId;
(function (ReservedInstancesId) {
    /**
     * @internal
     */
    ReservedInstancesId.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstancesId || (ReservedInstancesId = {}));
export var ReservedInstancesModification;
(function (ReservedInstancesModification) {
    /**
     * @internal
     */
    ReservedInstancesModification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstancesModification || (ReservedInstancesModification = {}));
export var DescribeReservedInstancesModificationsResult;
(function (DescribeReservedInstancesModificationsResult) {
    /**
     * @internal
     */
    DescribeReservedInstancesModificationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesModificationsResult || (DescribeReservedInstancesModificationsResult = {}));
export var DescribeReservedInstancesOfferingsRequest;
(function (DescribeReservedInstancesOfferingsRequest) {
    /**
     * @internal
     */
    DescribeReservedInstancesOfferingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesOfferingsRequest || (DescribeReservedInstancesOfferingsRequest = {}));
export var PricingDetail;
(function (PricingDetail) {
    /**
     * @internal
     */
    PricingDetail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PricingDetail || (PricingDetail = {}));
export var ReservedInstancesOffering;
(function (ReservedInstancesOffering) {
    /**
     * @internal
     */
    ReservedInstancesOffering.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReservedInstancesOffering || (ReservedInstancesOffering = {}));
export var DescribeReservedInstancesOfferingsResult;
(function (DescribeReservedInstancesOfferingsResult) {
    /**
     * @internal
     */
    DescribeReservedInstancesOfferingsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeReservedInstancesOfferingsResult || (DescribeReservedInstancesOfferingsResult = {}));
export var DescribeRouteTablesRequest;
(function (DescribeRouteTablesRequest) {
    /**
     * @internal
     */
    DescribeRouteTablesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeRouteTablesRequest || (DescribeRouteTablesRequest = {}));
export var DescribeRouteTablesResult;
(function (DescribeRouteTablesResult) {
    /**
     * @internal
     */
    DescribeRouteTablesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeRouteTablesResult || (DescribeRouteTablesResult = {}));
export var SlotDateTimeRangeRequest;
(function (SlotDateTimeRangeRequest) {
    /**
     * @internal
     */
    SlotDateTimeRangeRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SlotDateTimeRangeRequest || (SlotDateTimeRangeRequest = {}));
export var ScheduledInstanceRecurrenceRequest;
(function (ScheduledInstanceRecurrenceRequest) {
    /**
     * @internal
     */
    ScheduledInstanceRecurrenceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ScheduledInstanceRecurrenceRequest || (ScheduledInstanceRecurrenceRequest = {}));
export var DescribeScheduledInstanceAvailabilityRequest;
(function (DescribeScheduledInstanceAvailabilityRequest) {
    /**
     * @internal
     */
    DescribeScheduledInstanceAvailabilityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeScheduledInstanceAvailabilityRequest || (DescribeScheduledInstanceAvailabilityRequest = {}));
export var ScheduledInstanceRecurrence;
(function (ScheduledInstanceRecurrence) {
    /**
     * @internal
     */
    ScheduledInstanceRecurrence.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ScheduledInstanceRecurrence || (ScheduledInstanceRecurrence = {}));
export var ScheduledInstanceAvailability;
(function (ScheduledInstanceAvailability) {
    /**
     * @internal
     */
    ScheduledInstanceAvailability.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ScheduledInstanceAvailability || (ScheduledInstanceAvailability = {}));
export var DescribeScheduledInstanceAvailabilityResult;
(function (DescribeScheduledInstanceAvailabilityResult) {
    /**
     * @internal
     */
    DescribeScheduledInstanceAvailabilityResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeScheduledInstanceAvailabilityResult || (DescribeScheduledInstanceAvailabilityResult = {}));
export var SlotStartTimeRangeRequest;
(function (SlotStartTimeRangeRequest) {
    /**
     * @internal
     */
    SlotStartTimeRangeRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SlotStartTimeRangeRequest || (SlotStartTimeRangeRequest = {}));
export var DescribeScheduledInstancesRequest;
(function (DescribeScheduledInstancesRequest) {
    /**
     * @internal
     */
    DescribeScheduledInstancesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeScheduledInstancesRequest || (DescribeScheduledInstancesRequest = {}));
export var ScheduledInstance;
(function (ScheduledInstance) {
    /**
     * @internal
     */
    ScheduledInstance.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ScheduledInstance || (ScheduledInstance = {}));
export var DescribeScheduledInstancesResult;
(function (DescribeScheduledInstancesResult) {
    /**
     * @internal
     */
    DescribeScheduledInstancesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeScheduledInstancesResult || (DescribeScheduledInstancesResult = {}));
export var DescribeSecurityGroupReferencesRequest;
(function (DescribeSecurityGroupReferencesRequest) {
    /**
     * @internal
     */
    DescribeSecurityGroupReferencesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupReferencesRequest || (DescribeSecurityGroupReferencesRequest = {}));
export var SecurityGroupReference;
(function (SecurityGroupReference) {
    /**
     * @internal
     */
    SecurityGroupReference.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SecurityGroupReference || (SecurityGroupReference = {}));
export var DescribeSecurityGroupReferencesResult;
(function (DescribeSecurityGroupReferencesResult) {
    /**
     * @internal
     */
    DescribeSecurityGroupReferencesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupReferencesResult || (DescribeSecurityGroupReferencesResult = {}));
export var DescribeSecurityGroupRulesRequest;
(function (DescribeSecurityGroupRulesRequest) {
    /**
     * @internal
     */
    DescribeSecurityGroupRulesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupRulesRequest || (DescribeSecurityGroupRulesRequest = {}));
export var DescribeSecurityGroupRulesResult;
(function (DescribeSecurityGroupRulesResult) {
    /**
     * @internal
     */
    DescribeSecurityGroupRulesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupRulesResult || (DescribeSecurityGroupRulesResult = {}));
export var DescribeSecurityGroupsRequest;
(function (DescribeSecurityGroupsRequest) {
    /**
     * @internal
     */
    DescribeSecurityGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupsRequest || (DescribeSecurityGroupsRequest = {}));
export var SecurityGroup;
(function (SecurityGroup) {
    /**
     * @internal
     */
    SecurityGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SecurityGroup || (SecurityGroup = {}));
export var DescribeSecurityGroupsResult;
(function (DescribeSecurityGroupsResult) {
    /**
     * @internal
     */
    DescribeSecurityGroupsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSecurityGroupsResult || (DescribeSecurityGroupsResult = {}));
export var DescribeSnapshotAttributeRequest;
(function (DescribeSnapshotAttributeRequest) {
    /**
     * @internal
     */
    DescribeSnapshotAttributeRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSnapshotAttributeRequest || (DescribeSnapshotAttributeRequest = {}));
export var CreateVolumePermission;
(function (CreateVolumePermission) {
    /**
     * @internal
     */
    CreateVolumePermission.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateVolumePermission || (CreateVolumePermission = {}));
export var DescribeSnapshotAttributeResult;
(function (DescribeSnapshotAttributeResult) {
    /**
     * @internal
     */
    DescribeSnapshotAttributeResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSnapshotAttributeResult || (DescribeSnapshotAttributeResult = {}));
export var DescribeSnapshotsRequest;
(function (DescribeSnapshotsRequest) {
    /**
     * @internal
     */
    DescribeSnapshotsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSnapshotsRequest || (DescribeSnapshotsRequest = {}));
export var DescribeSnapshotsResult;
(function (DescribeSnapshotsResult) {
    /**
     * @internal
     */
    DescribeSnapshotsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSnapshotsResult || (DescribeSnapshotsResult = {}));
export var DescribeSpotDatafeedSubscriptionRequest;
(function (DescribeSpotDatafeedSubscriptionRequest) {
    /**
     * @internal
     */
    DescribeSpotDatafeedSubscriptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotDatafeedSubscriptionRequest || (DescribeSpotDatafeedSubscriptionRequest = {}));
export var DescribeSpotDatafeedSubscriptionResult;
(function (DescribeSpotDatafeedSubscriptionResult) {
    /**
     * @internal
     */
    DescribeSpotDatafeedSubscriptionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotDatafeedSubscriptionResult || (DescribeSpotDatafeedSubscriptionResult = {}));
export var DescribeSpotFleetInstancesRequest;
(function (DescribeSpotFleetInstancesRequest) {
    /**
     * @internal
     */
    DescribeSpotFleetInstancesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetInstancesRequest || (DescribeSpotFleetInstancesRequest = {}));
export var DescribeSpotFleetInstancesResponse;
(function (DescribeSpotFleetInstancesResponse) {
    /**
     * @internal
     */
    DescribeSpotFleetInstancesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetInstancesResponse || (DescribeSpotFleetInstancesResponse = {}));
export var EventType;
(function (EventType) {
    EventType["BATCH_CHANGE"] = "fleetRequestChange";
    EventType["ERROR"] = "error";
    EventType["INFORMATION"] = "information";
    EventType["INSTANCE_CHANGE"] = "instanceChange";
})(EventType || (EventType = {}));
export var DescribeSpotFleetRequestHistoryRequest;
(function (DescribeSpotFleetRequestHistoryRequest) {
    /**
     * @internal
     */
    DescribeSpotFleetRequestHistoryRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetRequestHistoryRequest || (DescribeSpotFleetRequestHistoryRequest = {}));
export var HistoryRecord;
(function (HistoryRecord) {
    /**
     * @internal
     */
    HistoryRecord.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HistoryRecord || (HistoryRecord = {}));
export var DescribeSpotFleetRequestHistoryResponse;
(function (DescribeSpotFleetRequestHistoryResponse) {
    /**
     * @internal
     */
    DescribeSpotFleetRequestHistoryResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetRequestHistoryResponse || (DescribeSpotFleetRequestHistoryResponse = {}));
export var DescribeSpotFleetRequestsRequest;
(function (DescribeSpotFleetRequestsRequest) {
    /**
     * @internal
     */
    DescribeSpotFleetRequestsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetRequestsRequest || (DescribeSpotFleetRequestsRequest = {}));
export var ExcessCapacityTerminationPolicy;
(function (ExcessCapacityTerminationPolicy) {
    ExcessCapacityTerminationPolicy["DEFAULT"] = "default";
    ExcessCapacityTerminationPolicy["NO_TERMINATION"] = "noTermination";
})(ExcessCapacityTerminationPolicy || (ExcessCapacityTerminationPolicy = {}));
export var SpotFleetMonitoring;
(function (SpotFleetMonitoring) {
    /**
     * @internal
     */
    SpotFleetMonitoring.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotFleetMonitoring || (SpotFleetMonitoring = {}));
export var InstanceNetworkInterfaceSpecification;
(function (InstanceNetworkInterfaceSpecification) {
    /**
     * @internal
     */
    InstanceNetworkInterfaceSpecification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InstanceNetworkInterfaceSpecification || (InstanceNetworkInterfaceSpecification = {}));
export var SpotPlacement;
(function (SpotPlacement) {
    /**
     * @internal
     */
    SpotPlacement.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotPlacement || (SpotPlacement = {}));
export var SpotFleetTagSpecification;
(function (SpotFleetTagSpecification) {
    /**
     * @internal
     */
    SpotFleetTagSpecification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotFleetTagSpecification || (SpotFleetTagSpecification = {}));
export var SpotFleetLaunchSpecification;
(function (SpotFleetLaunchSpecification) {
    /**
     * @internal
     */
    SpotFleetLaunchSpecification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotFleetLaunchSpecification || (SpotFleetLaunchSpecification = {}));
export var LaunchTemplateOverrides;
(function (LaunchTemplateOverrides) {
    /**
     * @internal
     */
    LaunchTemplateOverrides.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LaunchTemplateOverrides || (LaunchTemplateOverrides = {}));
export var LaunchTemplateConfig;
(function (LaunchTemplateConfig) {
    /**
     * @internal
     */
    LaunchTemplateConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LaunchTemplateConfig || (LaunchTemplateConfig = {}));
export var ClassicLoadBalancer;
(function (ClassicLoadBalancer) {
    /**
     * @internal
     */
    ClassicLoadBalancer.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ClassicLoadBalancer || (ClassicLoadBalancer = {}));
export var ClassicLoadBalancersConfig;
(function (ClassicLoadBalancersConfig) {
    /**
     * @internal
     */
    ClassicLoadBalancersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ClassicLoadBalancersConfig || (ClassicLoadBalancersConfig = {}));
export var TargetGroup;
(function (TargetGroup) {
    /**
     * @internal
     */
    TargetGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TargetGroup || (TargetGroup = {}));
export var TargetGroupsConfig;
(function (TargetGroupsConfig) {
    /**
     * @internal
     */
    TargetGroupsConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TargetGroupsConfig || (TargetGroupsConfig = {}));
export var LoadBalancersConfig;
(function (LoadBalancersConfig) {
    /**
     * @internal
     */
    LoadBalancersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LoadBalancersConfig || (LoadBalancersConfig = {}));
export var OnDemandAllocationStrategy;
(function (OnDemandAllocationStrategy) {
    OnDemandAllocationStrategy["LOWEST_PRICE"] = "lowestPrice";
    OnDemandAllocationStrategy["PRIORITIZED"] = "prioritized";
})(OnDemandAllocationStrategy || (OnDemandAllocationStrategy = {}));
export var ReplacementStrategy;
(function (ReplacementStrategy) {
    ReplacementStrategy["LAUNCH"] = "launch";
})(ReplacementStrategy || (ReplacementStrategy = {}));
export var SpotCapacityRebalance;
(function (SpotCapacityRebalance) {
    /**
     * @internal
     */
    SpotCapacityRebalance.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotCapacityRebalance || (SpotCapacityRebalance = {}));
export var SpotMaintenanceStrategies;
(function (SpotMaintenanceStrategies) {
    /**
     * @internal
     */
    SpotMaintenanceStrategies.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotMaintenanceStrategies || (SpotMaintenanceStrategies = {}));
export var SpotFleetRequestConfigData;
(function (SpotFleetRequestConfigData) {
    /**
     * @internal
     */
    SpotFleetRequestConfigData.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotFleetRequestConfigData || (SpotFleetRequestConfigData = {}));
export var SpotFleetRequestConfig;
(function (SpotFleetRequestConfig) {
    /**
     * @internal
     */
    SpotFleetRequestConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotFleetRequestConfig || (SpotFleetRequestConfig = {}));
export var DescribeSpotFleetRequestsResponse;
(function (DescribeSpotFleetRequestsResponse) {
    /**
     * @internal
     */
    DescribeSpotFleetRequestsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotFleetRequestsResponse || (DescribeSpotFleetRequestsResponse = {}));
export var DescribeSpotInstanceRequestsRequest;
(function (DescribeSpotInstanceRequestsRequest) {
    /**
     * @internal
     */
    DescribeSpotInstanceRequestsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotInstanceRequestsRequest || (DescribeSpotInstanceRequestsRequest = {}));
export var RunInstancesMonitoringEnabled;
(function (RunInstancesMonitoringEnabled) {
    /**
     * @internal
     */
    RunInstancesMonitoringEnabled.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RunInstancesMonitoringEnabled || (RunInstancesMonitoringEnabled = {}));
export var LaunchSpecification;
(function (LaunchSpecification) {
    /**
     * @internal
     */
    LaunchSpecification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LaunchSpecification || (LaunchSpecification = {}));
export var SpotInstanceStatus;
(function (SpotInstanceStatus) {
    /**
     * @internal
     */
    SpotInstanceStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotInstanceStatus || (SpotInstanceStatus = {}));
export var SpotInstanceRequest;
(function (SpotInstanceRequest) {
    /**
     * @internal
     */
    SpotInstanceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotInstanceRequest || (SpotInstanceRequest = {}));
export var DescribeSpotInstanceRequestsResult;
(function (DescribeSpotInstanceRequestsResult) {
    /**
     * @internal
     */
    DescribeSpotInstanceRequestsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotInstanceRequestsResult || (DescribeSpotInstanceRequestsResult = {}));
export var DescribeSpotPriceHistoryRequest;
(function (DescribeSpotPriceHistoryRequest) {
    /**
     * @internal
     */
    DescribeSpotPriceHistoryRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotPriceHistoryRequest || (DescribeSpotPriceHistoryRequest = {}));
export var SpotPrice;
(function (SpotPrice) {
    /**
     * @internal
     */
    SpotPrice.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SpotPrice || (SpotPrice = {}));
export var DescribeSpotPriceHistoryResult;
(function (DescribeSpotPriceHistoryResult) {
    /**
     * @internal
     */
    DescribeSpotPriceHistoryResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSpotPriceHistoryResult || (DescribeSpotPriceHistoryResult = {}));
export var DescribeStaleSecurityGroupsRequest;
(function (DescribeStaleSecurityGroupsRequest) {
    /**
     * @internal
     */
    DescribeStaleSecurityGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStaleSecurityGroupsRequest || (DescribeStaleSecurityGroupsRequest = {}));
export var StaleIpPermission;
(function (StaleIpPermission) {
    /**
     * @internal
     */
    StaleIpPermission.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StaleIpPermission || (StaleIpPermission = {}));
export var StaleSecurityGroup;
(function (StaleSecurityGroup) {
    /**
     * @internal
     */
    StaleSecurityGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StaleSecurityGroup || (StaleSecurityGroup = {}));
export var DescribeStaleSecurityGroupsResult;
(function (DescribeStaleSecurityGroupsResult) {
    /**
     * @internal
     */
    DescribeStaleSecurityGroupsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStaleSecurityGroupsResult || (DescribeStaleSecurityGroupsResult = {}));
export var DescribeStoreImageTasksRequest;
(function (DescribeStoreImageTasksRequest) {
    /**
     * @internal
     */
    DescribeStoreImageTasksRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStoreImageTasksRequest || (DescribeStoreImageTasksRequest = {}));
export var StoreImageTaskResult;
(function (StoreImageTaskResult) {
    /**
     * @internal
     */
    StoreImageTaskResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StoreImageTaskResult || (StoreImageTaskResult = {}));
export var DescribeStoreImageTasksResult;
(function (DescribeStoreImageTasksResult) {
    /**
     * @internal
     */
    DescribeStoreImageTasksResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStoreImageTasksResult || (DescribeStoreImageTasksResult = {}));
export var DescribeSubnetsRequest;
(function (DescribeSubnetsRequest) {
    /**
     * @internal
     */
    DescribeSubnetsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSubnetsRequest || (DescribeSubnetsRequest = {}));
export var DescribeSubnetsResult;
(function (DescribeSubnetsResult) {
    /**
     * @internal
     */
    DescribeSubnetsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSubnetsResult || (DescribeSubnetsResult = {}));
export var DescribeTagsRequest;
(function (DescribeTagsRequest) {
    /**
     * @internal
     */
    DescribeTagsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTagsRequest || (DescribeTagsRequest = {}));
export var TagDescription;
(function (TagDescription) {
    /**
     * @internal
     */
    TagDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagDescription || (TagDescription = {}));
export var DescribeTagsResult;
(function (DescribeTagsResult) {
    /**
     * @internal
     */
    DescribeTagsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTagsResult || (DescribeTagsResult = {}));
export var DescribeTrafficMirrorFiltersRequest;
(function (DescribeTrafficMirrorFiltersRequest) {
    /**
     * @internal
     */
    DescribeTrafficMirrorFiltersRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorFiltersRequest || (DescribeTrafficMirrorFiltersRequest = {}));
export var DescribeTrafficMirrorFiltersResult;
(function (DescribeTrafficMirrorFiltersResult) {
    /**
     * @internal
     */
    DescribeTrafficMirrorFiltersResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorFiltersResult || (DescribeTrafficMirrorFiltersResult = {}));
export var DescribeTrafficMirrorSessionsRequest;
(function (DescribeTrafficMirrorSessionsRequest) {
    /**
     * @internal
     */
    DescribeTrafficMirrorSessionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorSessionsRequest || (DescribeTrafficMirrorSessionsRequest = {}));
export var DescribeTrafficMirrorSessionsResult;
(function (DescribeTrafficMirrorSessionsResult) {
    /**
     * @internal
     */
    DescribeTrafficMirrorSessionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorSessionsResult || (DescribeTrafficMirrorSessionsResult = {}));
export var DescribeTrafficMirrorTargetsRequest;
(function (DescribeTrafficMirrorTargetsRequest) {
    /**
     * @internal
     */
    DescribeTrafficMirrorTargetsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorTargetsRequest || (DescribeTrafficMirrorTargetsRequest = {}));
export var DescribeTrafficMirrorTargetsResult;
(function (DescribeTrafficMirrorTargetsResult) {
    /**
     * @internal
     */
    DescribeTrafficMirrorTargetsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrafficMirrorTargetsResult || (DescribeTrafficMirrorTargetsResult = {}));
export var DescribeTransitGatewayAttachmentsRequest;
(function (DescribeTransitGatewayAttachmentsRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayAttachmentsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayAttachmentsRequest || (DescribeTransitGatewayAttachmentsRequest = {}));
export var TransitGatewayAttachmentAssociation;
(function (TransitGatewayAttachmentAssociation) {
    /**
     * @internal
     */
    TransitGatewayAttachmentAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TransitGatewayAttachmentAssociation || (TransitGatewayAttachmentAssociation = {}));
export var TransitGatewayAttachment;
(function (TransitGatewayAttachment) {
    /**
     * @internal
     */
    TransitGatewayAttachment.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TransitGatewayAttachment || (TransitGatewayAttachment = {}));
export var DescribeTransitGatewayAttachmentsResult;
(function (DescribeTransitGatewayAttachmentsResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayAttachmentsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayAttachmentsResult || (DescribeTransitGatewayAttachmentsResult = {}));
export var DescribeTransitGatewayConnectPeersRequest;
(function (DescribeTransitGatewayConnectPeersRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayConnectPeersRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayConnectPeersRequest || (DescribeTransitGatewayConnectPeersRequest = {}));
export var DescribeTransitGatewayConnectPeersResult;
(function (DescribeTransitGatewayConnectPeersResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayConnectPeersResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayConnectPeersResult || (DescribeTransitGatewayConnectPeersResult = {}));
export var DescribeTransitGatewayConnectsRequest;
(function (DescribeTransitGatewayConnectsRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayConnectsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayConnectsRequest || (DescribeTransitGatewayConnectsRequest = {}));
export var DescribeTransitGatewayConnectsResult;
(function (DescribeTransitGatewayConnectsResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayConnectsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayConnectsResult || (DescribeTransitGatewayConnectsResult = {}));
export var DescribeTransitGatewayMulticastDomainsRequest;
(function (DescribeTransitGatewayMulticastDomainsRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayMulticastDomainsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayMulticastDomainsRequest || (DescribeTransitGatewayMulticastDomainsRequest = {}));
export var DescribeTransitGatewayMulticastDomainsResult;
(function (DescribeTransitGatewayMulticastDomainsResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayMulticastDomainsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayMulticastDomainsResult || (DescribeTransitGatewayMulticastDomainsResult = {}));
export var DescribeTransitGatewayPeeringAttachmentsRequest;
(function (DescribeTransitGatewayPeeringAttachmentsRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayPeeringAttachmentsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayPeeringAttachmentsRequest || (DescribeTransitGatewayPeeringAttachmentsRequest = {}));
export var DescribeTransitGatewayPeeringAttachmentsResult;
(function (DescribeTransitGatewayPeeringAttachmentsResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayPeeringAttachmentsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayPeeringAttachmentsResult || (DescribeTransitGatewayPeeringAttachmentsResult = {}));
export var DescribeTransitGatewayRouteTablesRequest;
(function (DescribeTransitGatewayRouteTablesRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayRouteTablesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayRouteTablesRequest || (DescribeTransitGatewayRouteTablesRequest = {}));
export var DescribeTransitGatewayRouteTablesResult;
(function (DescribeTransitGatewayRouteTablesResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayRouteTablesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayRouteTablesResult || (DescribeTransitGatewayRouteTablesResult = {}));
export var DescribeTransitGatewaysRequest;
(function (DescribeTransitGatewaysRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewaysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewaysRequest || (DescribeTransitGatewaysRequest = {}));
export var DescribeTransitGatewaysResult;
(function (DescribeTransitGatewaysResult) {
    /**
     * @internal
     */
    DescribeTransitGatewaysResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewaysResult || (DescribeTransitGatewaysResult = {}));
export var DescribeTransitGatewayVpcAttachmentsRequest;
(function (DescribeTransitGatewayVpcAttachmentsRequest) {
    /**
     * @internal
     */
    DescribeTransitGatewayVpcAttachmentsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayVpcAttachmentsRequest || (DescribeTransitGatewayVpcAttachmentsRequest = {}));
export var DescribeTransitGatewayVpcAttachmentsResult;
(function (DescribeTransitGatewayVpcAttachmentsResult) {
    /**
     * @internal
     */
    DescribeTransitGatewayVpcAttachmentsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTransitGatewayVpcAttachmentsResult || (DescribeTransitGatewayVpcAttachmentsResult = {}));
export var DescribeTrunkInterfaceAssociationsRequest;
(function (DescribeTrunkInterfaceAssociationsRequest) {
    /**
     * @internal
     */
    DescribeTrunkInterfaceAssociationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrunkInterfaceAssociationsRequest || (DescribeTrunkInterfaceAssociationsRequest = {}));
export var DescribeTrunkInterfaceAssociationsResult;
(function (DescribeTrunkInterfaceAssociationsResult) {
    /**
     * @internal
     */
    DescribeTrunkInterfaceAssociationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeTrunkInterfaceAssociationsResult || (DescribeTrunkInterfaceAssociationsResult = {}));
export var DescribeVolumeAttributeRequest;
(function (DescribeVolumeAttributeRequest) {
    /**
     * @internal
     */
    DescribeVolumeAttributeRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumeAttributeRequest || (DescribeVolumeAttributeRequest = {}));
export var DescribeVolumeAttributeResult;
(function (DescribeVolumeAttributeResult) {
    /**
     * @internal
     */
    DescribeVolumeAttributeResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumeAttributeResult || (DescribeVolumeAttributeResult = {}));
export var DescribeVolumesRequest;
(function (DescribeVolumesRequest) {
    /**
     * @internal
     */
    DescribeVolumesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumesRequest || (DescribeVolumesRequest = {}));
export var DescribeVolumesResult;
(function (DescribeVolumesResult) {
    /**
     * @internal
     */
    DescribeVolumesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumesResult || (DescribeVolumesResult = {}));
export var DescribeVolumesModificationsRequest;
(function (DescribeVolumesModificationsRequest) {
    /**
     * @internal
     */
    DescribeVolumesModificationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumesModificationsRequest || (DescribeVolumesModificationsRequest = {}));
export var VolumeModification;
(function (VolumeModification) {
    /**
     * @internal
     */
    VolumeModification.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeModification || (VolumeModification = {}));
export var DescribeVolumesModificationsResult;
(function (DescribeVolumesModificationsResult) {
    /**
     * @internal
     */
    DescribeVolumesModificationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumesModificationsResult || (DescribeVolumesModificationsResult = {}));
export var DescribeVolumeStatusRequest;
(function (DescribeVolumeStatusRequest) {
    /**
     * @internal
     */
    DescribeVolumeStatusRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumeStatusRequest || (DescribeVolumeStatusRequest = {}));
export var VolumeStatusAction;
(function (VolumeStatusAction) {
    /**
     * @internal
     */
    VolumeStatusAction.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusAction || (VolumeStatusAction = {}));
export var VolumeStatusAttachmentStatus;
(function (VolumeStatusAttachmentStatus) {
    /**
     * @internal
     */
    VolumeStatusAttachmentStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusAttachmentStatus || (VolumeStatusAttachmentStatus = {}));
export var VolumeStatusEvent;
(function (VolumeStatusEvent) {
    /**
     * @internal
     */
    VolumeStatusEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusEvent || (VolumeStatusEvent = {}));
export var VolumeStatusDetails;
(function (VolumeStatusDetails) {
    /**
     * @internal
     */
    VolumeStatusDetails.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusDetails || (VolumeStatusDetails = {}));
export var VolumeStatusInfo;
(function (VolumeStatusInfo) {
    /**
     * @internal
     */
    VolumeStatusInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusInfo || (VolumeStatusInfo = {}));
export var VolumeStatusItem;
(function (VolumeStatusItem) {
    /**
     * @internal
     */
    VolumeStatusItem.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VolumeStatusItem || (VolumeStatusItem = {}));
export var DescribeVolumeStatusResult;
(function (DescribeVolumeStatusResult) {
    /**
     * @internal
     */
    DescribeVolumeStatusResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeVolumeStatusResult || (DescribeVolumeStatusResult = {}));
//# sourceMappingURL=models_3.js.map